import { render, staticRenderFns } from "./SectionBuffer.vue?vue&type=template&id=00f2edfd&scoped=true&"
import script from "./SectionBuffer.vue?vue&type=script&lang=js&"
export * from "./SectionBuffer.vue?vue&type=script&lang=js&"
import style0 from "./SectionBuffer.vue?vue&type=style&index=0&id=00f2edfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2edfd",
  null
  
)

export default component.exports